export default {
  backendUrl: "http://38.242.216.154:3005/api/"
  //backendUrl: "http://localhost:3005/api/"
  //backendUrl: "http://159.89.50.20:3005/api/"
};
